var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.467,39.724c-0.196,3.274-1.656,6.267-4.108,8.438c-2.441,2.171-5.58,3.25-8.867,3.054 c-3.262-0.196-6.255-1.656-8.425-4.108c-2.171-2.441-3.25-5.592-3.054-8.867c0.392-6.488,5.801-11.504,12.227-11.504 c0.245,0,0.491,0.012,0.748,0.024C133.721,27.166,138.872,32.991,138.467,39.724z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "217.251,187.664 217.251,194.078 176.608,229.264 174.56,229.264 174.56,187.664  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.792,51.399c-0.429,0.478-0.883,0.92-1.361,1.349c-3.385,3.005-7.665,4.624-12.141,4.624 c-0.233,0-0.466-0.012-0.699-0.025l-3.36,16.654c-0.294,1.447-1.57,2.453-2.992,2.453c-0.208,0-0.405-0.012-0.613-0.061 c-1.656-0.331-2.735-1.95-2.404-3.606l3.36-16.667c-2.6-1.006-4.942-2.612-6.88-4.722H38.749v177.864h129.679v-44.665 c0-1.692,1.374-3.066,3.066-3.066h45.757V51.399H139.792z M185.181,148.959H70.807c-1.692,0-3.066-1.361-3.066-3.066 c0-1.692,1.374-3.066,3.066-3.066h114.374c1.692,0,3.066,1.374,3.066,3.066C188.247,147.598,186.873,148.959,185.181,148.959z  M185.181,117.11H70.807c-1.692,0-3.066-1.374-3.066-3.066c0-1.692,1.374-3.066,3.066-3.066h114.374 c1.692,0,3.066,1.374,3.066,3.066C188.247,115.736,186.873,117.11,185.181,117.11z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.4f29bf6408f85adad930ed47c954387e.svg";
export { ForwardRef as ReactComponent };